import { render, staticRenderFns } from "./ListTeamRatingMlbb.vue?vue&type=template&id=29d16f9c&scoped=true"
import script from "./ListTeamRatingMlbb.vue?vue&type=script&lang=js"
export * from "./ListTeamRatingMlbb.vue?vue&type=script&lang=js"
import style0 from "./ListTeamRatingMlbb.vue?vue&type=style&index=0&id=29d16f9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d16f9c",
  null
  
)

export default component.exports